export const resolveUrlWithNextParam = (destinationUrl: string): string =>
  `${destinationUrl}?next=${encodeURIComponent(
    `${window.location.pathname}${window.location.search}${window.location.hash}`,
  )}`
